import {probesActionTypes} from './home.actionTypes';
import {Network} from '../../../utils/network';
import {navigateWithNavigation} from '../../../navigation/rootNavigation';

export const fetchProbesRequest =
  (data = {}, parentFilter) =>
  async (dispatch, state) => {
    try {
      let payload = {
        ...data,
        probe_type: 'promo,normal,exclude',
        isHashtagsNull: true,
      };
      let res;
      dispatch({
        type: probesActionTypes.FETCH_PROBES_REQUEST,
        payload: null,
      });

      if (payload) {
        res = await Network.getProbes(payload);
      } else {
        res = await Network.getProbes({});
        if (parentFilter !== undefined) {
          res = await Network.getProbes({});

          const probes = res.data.probes;

          const filteredProbes = probes.filter(
            probe => probe.parent_id === parseInt(parentFilter),
          );

          res.data = {...res.data, probes: filteredProbes};
          dispatch({
            type: probesActionTypes.FETCH_PROBES_MULTI_SUCCESS,
            payload: res.data,
          });
        }
      }

      //  const liveData = (res?.data?.probes ?? []).map((item) => ({
      //    id: item.id,
      //    newYCP: item.newYCP,
      //    newNCP: item.newNCP,
      //  }));
      //dispatch(receiveMessage(liveData));
      dispatch({
        type: probesActionTypes.FETCH_PROBES_SUCCESS,
        payload: res.data,
      });
      if (!data) {
        /*dispatch({
          type: probesActionTypes.BANNER_PROBES_SUCCESS,
          payload: res.data,
        });*/
      }
    } catch (e) {
      dispatch({
        type: probesActionTypes.FETCH_PROBES_ERROR,
        payload: e.response,
      });
    }
  };

export const fetchHashTagProbesRequest =
  (data, parentFilter) => async (dispatch, state) => {
    try {
      let res;
      dispatch({
        type: probesActionTypes.FETCH_HASHTAG_PROBES_REQUEST,
        payload: null,
      });

      res = await Network.getProbes(data);

      dispatch({
        type: probesActionTypes.FETCH_HASHTAG_PROBES_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: probesActionTypes.FETCH_HASHTAG_PROBES_ERROR,
        payload: e.response,
      });
    }
  };

export const removeProbe =
  (id, isHashtag = false) =>
  async (dispatch, state) => {
    try {
      const data = isHashtag
        ? state().probesReducer?.hashData
        : state().probesReducer?.data;
      let tempData = [];
      let isExist = false;
      var removeByAttr = function (arr, attr, value) {
        var i = arr.length;
        while (i--) {
          if (
            arr[i] &&
            arr[i].hasOwnProperty(attr) &&
            arguments.length > 2 &&
            arr[i][attr] === value
          ) {
            isExist = true;
            arr.splice(i, 1);
            break;
          }
        }
        return arr;
      };
      tempData = removeByAttr(data?.probes, 'id', id);
      if (isExist) {
        data.probes = tempData;
        if (isHashtag) {
          dispatch({
            type: probesActionTypes.FETCH_HASHTAG_PROBES_SUCCESS,
            payload: {...data},
          });
        } else {
          dispatch({
            type: probesActionTypes.FETCH_PROBES_SUCCESS,
            payload: {...data},
          });
        }
      }
    } catch (e) {
      if (isHashtag) {
        dispatch({
          type: probesActionTypes.FETCH_HASHTAG_PROBES_ERROR,
          payload: e.response,
        });
      } else {
        dispatch({
          type: probesActionTypes.FETCH_PROBES_ERROR,
          payload: e.response,
        });
      }
    }
  };

export const fetchProbesRequestDetails =
  (data, parentFilter, isOnEventDetailsScreen = false, contestId) =>
  async (dispatch, getState) => {
    try {
      let res;
      if (data) {
        if (contestId) {
          res = await Network.contestEvents(data);
        } else {
          res = await Network.getProbes(data);
        }
      } else {
        if (parentFilter !== undefined) {
          let probes;
          let resParent;

          if (contestId) {
            resParent = await Network.contestEvents({
              probeid: parseInt(parentFilter),
            });
          } else {
            resParent = await Network.getProbes({
              probeid: parseInt(parentFilter),
            });
          }
          let probesData;
          if (contestId) {
            probesData = getState().eventsData?.data?.probes;
          } else {
            probesData = getState().probes?.data?.probes;
          }

          if (probesData && probesData.length) {
            probes = probesData;
          } else {
            if (contestId) {
              res = await Network.contestEvents({contest_id: +contestId});
            } else {
              res = await Network.getProbes({});
            }

            probes = res.data.probes;
          }

          //const probes = res.data.probes;
          const filteredProbes = probes.filter(
            probe => probe.parent_id === parseInt(parentFilter),
          );
          const sortedProbes = [];
          if (resParent?.data?.probes) {
            const subEventTitle =
              resParent?.data?.probes[0]?.sub_events_ids || [];
            filteredProbes.map((data, index) => {
              const subTitileIndex = subEventTitle.indexOf(data?.id);
              if (subTitileIndex > -1) {
                sortedProbes[subTitileIndex] = filteredProbes[index];
              }
            });
          }
          if (sortedProbes.length > 0) {
            return {
              probes: sortedProbes,
              parentTitle: resParent?.data?.probes[0]?.title,
            };
          } else {
            return {
              probes: filteredProbes,
              parentTitle: resParent?.data?.probes[0]?.title,
            };
          }

          // console.log(filteredProbes);
          //res.data = { ...res.data, probes: filteredProbes };
        }
      }

      // if (res.data.probes?.length === 0) {
      //   !isOnEventDetailsScreen &&
      //     trackMoengageEvent('Event Click', {
      //       active: false,
      //     });
      // }
      // !isOnEventDetailsScreen &&
      //   trackMoengageEvent('Event Click', {
      //     active: true,
      //     Category: res?.data?.probes[0]?.category,
      //     SubCategory: res?.data?.probes[0]?.subcategory,
      //     id: res?.data?.probes[0]?.id,
      //     Volume: res?.data?.probes[0]?.volume,
      //     PriceYes: res?.data?.probes[0]?.newYCP,
      //     PriceNo: res?.data?.probes[0]?.newNCP,
      //     MarketOpen: res?.data?.probes[0]?.start_date,
      //     MarketEnd: res?.data?.probes[0]?.endsat,
      //     MarketSettlement: res?.data?.probes[0]?.settledate,
      //     SettlementLink: res?.data?.probes[0]?.source,
      //     Type: res?.data?.probes[0]?.is_price_editable ? 'IM' : 'CDA',
      //     Tip: res?.data?.probes[0]?.tooltip,
      //   });
      dispatch({
        type: probesActionTypes.FETCH_PROBES_MULTI_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: probesActionTypes.FETCH_PROBES_ERROR,
        payload: e.response,
      });
    }
  };

export const setProbeEmpty = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: probesActionTypes.FETCH_PROBES_MULTI_SUCCESS,
      payload: {},
    });
  } catch (e) {}
};

export const setHomeFilterCategory =
  (filterType = null) =>
  async (dispatch, state) => {
    dispatch({
      type: probesActionTypes.SET_FILTER_ORDER,
      payload: filterType,
    });
  };
export const checkOtpLessRedirection =
  (sId = null) =>
  async (dispatch, getState) => {
    const isLogin = getState().utilReducer.isAppLogin;
    if (!isLogin) {
      navigateWithNavigation('Login', {sId});
    }
  };
